import {Dispatch} from "redux"
import {connect} from "react-redux"

// Models
import {RootState} from "../../../models"
import {DoctorStatsStateType} from "../models"
import {RecordsPeriod} from "../utils/dateRange"

// Actions
import * as a from "../store/actions"

// Selectors
import {
    selectAvailableRecords,
    selectAvailableRecordsCurrentPage,
    selectAvailableRecordsError,
    selectAvailableRecordsFetching,
    selectAvailableRecordsTotal,
    selectAvailableRecordsSize
} from "../store/selectors"

/**
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
    availableRecords: selectAvailableRecords(state),
    availableRecordsCurrentPage: selectAvailableRecordsCurrentPage(state),
    availableRecordsFetching: selectAvailableRecordsFetching(state),
    availableRecordsError: selectAvailableRecordsError(state),
    availableRecordsTotal: selectAvailableRecordsTotal(state),
    availableRecordsSize: selectAvailableRecordsSize(state),
});

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchAvailableRecords: () => dispatch(a.fetchAvailableRecordsAsync.request()),
    setAvailableRecordsPage: (page: number) => dispatch(a.setAvailableRecordsPage(page)),
    setAvailableRecordsSize: (size: string) => dispatch(a.setAvailableRecordSize(size)),
    setAvailableRecordsPeriod: (period: RecordsPeriod) => dispatch(a.setAvailableRecordsPeriod(period)),
});

export type WithDoctorAvailableRecordsType = {
    availableRecordsFetching: DoctorStatsStateType["availableRecordsFetching"]
    availableRecordsError: DoctorStatsStateType["availableRecordsError"]
    availableRecords: DoctorStatsStateType["availableRecords"]
    availableRecordsTotal: DoctorStatsStateType["availableRecordsTotal"]
    availableRecordsCurrentPage: DoctorStatsStateType["availableRecordsCurrentPage"]
    availableRecordsSize: DoctorStatsStateType["availableRecordsSize"]
    fetchAvailableRecords(): void
    setAvailableRecordsPage(page: number): void
    setAvailableRecordsSize(size: string): void
    setAvailableRecordsPeriod(period: RecordsPeriod): void
}

/**
 * @param BaseComponent
 */
export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)
